// Bu liste ADwise content/rules.py:AGE_BRACKETS + GROUP_TYPES ile birebir aynı
// olmalıdır. ADwise tarafında değişirse buradaki kopyayı güncelle, aksi halde
// import 422 verir.

export const AGE_BRACKETS = [
  "(18-25)", "(26-32)", "(33-42)", "(42-60)", "(60+)",
];

export const AGE_BRACKET_LABELS_TR = {
  "(18-25)": "Genç (18-25)",
  "(26-32)": "Genç Yetişkin (26-32)",
  "(33-42)": "Yetişkin (33-42)",
  "(42-60)": "Olgun (42-60)",
  "(60+)":   "Kıdemli (60+)",
};

export const GROUP_TYPES = [
  "solo",
  "z_couple", "young_couple", "mature_couple",
  "mixed_pair",
  "z_male_group", "young_male_group", "mature_male_group",
  "z_female_group", "young_female_group", "mature_female_group",
  "z_mixed_group", "young_mixed_group", "mature_mixed_group",
  "empty",
];

export const GROUP_TYPE_LABELS_TR = {
  solo: "Tek kişi",
  z_couple: "Z çift",
  young_couple: "Genç çift",
  mature_couple: "Olgun çift",
  mixed_pair: "Karışık ikili",
  z_male_group: "Z erkek grubu",
  young_male_group: "Genç erkek grubu",
  mature_male_group: "Olgun erkek grubu",
  z_female_group: "Z kadın grubu",
  young_female_group: "Genç kadın grubu",
  mature_female_group: "Olgun kadın grubu",
  z_mixed_group: "Z karışık grup",
  young_mixed_group: "Genç karışık grup",
  mature_mixed_group: "Olgun karışık grup",
  empty: "Boş kiosk",
};

export const GENDERS = ["male", "female"];
export const GENDER_LABELS_TR = { male: "Erkek", female: "Kadın" };

export const ORIENTATIONS = ["any", "portrait", "landscape"];
export const ORIENTATION_LABELS_TR = {
  any: "Tümü",
  portrait: "Dikey",
  landscape: "Yatay",
};

export const MEDIA_TYPES = ["image", "video", "html"];
